var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealStateAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_495_21640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 29.17,
    height: 29.17,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_495_21640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7001 17.3199V8.78866L17.0153 4.11399L10.3305 8.78866V12.0609H9.11508V8.20432L17.0153 2.57132L24.9155 8.20432V17.3199H23.7001ZM17.7399 9.60673H18.7215V8.62504H17.7399V9.60673ZM15.309 9.60673H16.2907V8.62504H15.309V9.60673ZM17.7399 12.0376H18.7215V11.0559H17.7399V12.0376ZM15.309 12.0376H16.2907V11.0559H15.309V12.0376ZM16.5946 25.6175L7.33872 22.9202V24.4956H2.47705V14.5853H10.223L17.5716 17.2872C18.0063 17.4524 18.3807 17.7492 18.6947 18.1778C19.0087 18.6063 19.1657 19.154 19.1657 19.8209H22.8119C23.5443 19.8209 24.1091 20.078 24.5065 20.5922C24.9038 21.1064 25.1025 21.7843 25.1025 22.6257V22.9529L16.5946 25.6175ZM3.69244 23.2802H6.12327V15.8007H3.69244V23.2802ZM16.5338 24.3273L23.8123 22.0788C23.7982 21.7624 23.7005 21.5096 23.519 21.3203C23.3374 21.131 23.1017 21.0363 22.8119 21.0363H17.1181C16.5681 21.0363 16.0243 20.9997 15.4867 20.9265C14.9491 20.8532 14.4567 20.7387 14.0095 20.5829L11.6558 19.8069L12.0975 18.6195L14.3881 19.4095C14.7995 19.5622 15.2638 19.669 15.7812 19.7298C16.2985 19.7905 17.0215 19.8209 17.9502 19.8209C17.9502 19.4422 17.8805 19.1361 17.741 18.9023C17.6016 18.6686 17.4017 18.5057 17.1415 18.4138L10.0313 15.8007H7.33872V21.644L16.5338 24.3273Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealStateAgent);
export default __webpack_public_path__ + "static/media/real-state-agent.9b719677d8e5bef5028e0cf99c1ea1e1.svg";
export { ForwardRef as ReactComponent };